// The Smile Company : carrousel scroll-snap accessible (boutons précédent/suivant, statut annoncé, pas d'autoplay).
if (!customElements.get('tsc-carousel')) {
  customElements.define(
    'tsc-carousel',
    class TscCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        if (!this.track) return;

        this.slides = [...this.track.children];
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.update();
      }

      currentIndex() {
        const left = this.track.scrollLeft;
        let index = 0;
        let best = Infinity;
        this.slides.forEach((slide, i) => {
          const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
          if (distance < best) {
            best = distance;
            index = i;
          }
        });
        return index;
      }

      go(direction) {
        const target = this.slides[Math.min(this.slides.length - 1, Math.max(0, this.currentIndex() + direction))];
        if (!target) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const index = this.currentIndex();
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = atEnd;
        if (this.status) this.status.textContent = `${index + 1} / ${this.slides.length}`;
      }
    }
  );
}
